import { Request } from "../../hooks/Request";
import { Circle } from "../../components/Animation";
import { Page, Document, PDFViewer, Image, Link } from "@react-pdf/renderer";
import View from "../../components/GeneratePdf/View";
import Text from "../../components/GeneratePdf/Text";
import * as dayjs from "dayjs";


const ReportPrecintosPDF = ({ companyId, year }) => {
	const { data, loading } = Request({
		urlApi: `/Procedure/pag?CompanyId=${companyId}&Year=${year}&Fieldnames=registroDePrecinto&Fieldnames=codigoDeInterno&Fieldnames=referenciaCliente&Fieldnames=nroDeOrdenDeCompra&Fieldnames=descripciónDeLaMercancía&Fieldnames=numeroDeEmbarque&Fieldnames=numeroDeContenedor&IsPaginado=false`,
	});

	if (!loading) {
		return <Circle />;
	}

	const processedData = data
		? data
			.filter(
				(p) =>
					p.registroDePrecinto &&
					p.registroDePrecinto.subDatas &&
					p.registroDePrecinto.subDatas.length > 0
			)
		: [];

	return <RenderReportPrecintosPDF data={processedData} year={year} />;
};

const formatDate = (dateStr) => {
	if (!dateStr || dateStr === "") return "";
	return dayjs(dateStr).format("DD/MM/YYYY");
};

const getDocsArray = (jsonStr) => {
	try {
		const docs = JSON.parse(jsonStr);
		if (Array.isArray(docs)) {
			return docs;
		}
	} catch (e) {
		return [];
	}
	return [];
};

const RenderReportPrecintosPDF = ({ data, year }) => {
	const w = {
		c1: "8%",
		c2: "12%",
		c3: "10%",
		c4: "15%",
		c5: "7%",
		c6: "10%",
		c7: "62%", // Group 1 total
		c8: "5%",
		c9: "8%",
		c10: "15%",
		c11: "10%",
		c12: "38%", // Group 2 total
	};

	// Helper for precinto sub-widths (percentages relative to the 38% container)
	const subW = {
		n1: (5 / 38) * 100 + "%",
		n2: (8 / 38) * 100 + "%",
		n3: (15 / 38) * 100 + "%",
		n4: (10 / 38) * 100 + "%",
	};

	return (
		<div className="min-w-[80vw]">
			<PDFViewer
				style={{
					width: "100%",
					height: window.innerHeight - 100,
				}}
			>
				<Document>
					<Page
						size="A4"
						orientation="landscape"
						style={{
							padding: "30px",
							flexDirection: "column",
						}}
					>
						<View flexDirection="column">
							<View style={{ marginBottom: "10px" }} justifyContent="space-between" alignItems="center">
								<View width="20%">
									<Image
										src="https://res.cloudinary.com/joeldes/image/upload/v1703637339/Agda/logo_nw1jah.png"
										style={{ height: "40px" }}
									/>
								</View>
								<View width="60%" alignItems="center">
									<Text bold fontSize="14px">
										REPORTE DE PRECINTOS UTILIZADOS
									</Text>
									<Text fontSize="10px">Gestión: {year}</Text>
								</View>
								<View width="20%" alignItems="flex-end">
									<Text fontSize="8px">Fecha: {dayjs().format("DD/MM/YYYY")}</Text>
									<Text fontSize="8px">Hora: {dayjs().format("HH:mm:ss")}</Text>
								</View>
							</View>

							{/* Table Header Group */}
							<View borderContent width="100%" backgroundColor="#f9fafb">
								<View width={w.c7} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="10px">Carpeta</Text>
								</View>
								<View width={w.c12} justifyContent="center">
									<Text bold textAlign="center" fontSize="10px">Precintos</Text>
								</View>
							</View>

							{/* Table Header Columns */}
							<View border={{ left: true, right: true, bottom: true }} width="100%">
								<View width={w.c1} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Carpeta</Text>
								</View>
								<View width={w.c2} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Ref. Cliente</Text>
								</View>
								<View width={w.c3} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Orden Comp</Text>
								</View>
								<View width={w.c4} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Mercadería</Text>
								</View>
								<View width={w.c5} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Embarque</Text>
								</View>
								<View width={w.c6} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Contenedor</Text>
								</View>
								<View width={w.c8} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Numero</Text>
								</View>
								<View width={w.c9} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Fecha</Text>
								</View>
								<View width={w.c10} border={{ right: true }} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Obs</Text>
								</View>
								<View width={w.c11} justifyContent="center">
									<Text bold textAlign="center" fontSize="8px">Documentos</Text>
								</View>
							</View>

							{/* Table Data */}
							{data.map((p, pIdx) => (
								<View key={pIdx} border={{ left: true, right: true, bottom: true }} width="100%">
									<View width={w.c1} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.codigoDeInterno}</Text>
									</View>
									<View width={w.c2} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.referenciaCliente}</Text>
									</View>
									<View width={w.c3} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.nroDeOrdenDeCompra}</Text>
									</View>
									<View width={w.c4} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.descripciónDeLaMercancía}</Text>
									</View>
									<View width={w.c5} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.numeroDeEmbarque}</Text>
									</View>
									<View width={w.c6} border={{ right: true }} justifyContent="center">
										<Text textAlign="center" fontSize="8px">{p.numeroDeContenedor}</Text>
									</View>

									{/* Sub-table for Precintos */}
									<View width={w.c12} flexDirection="column">
										{p.registroDePrecinto.subDatas.map((s, sIdx) => (
											<View
												key={sIdx}
												width="100%"
												border={{ bottom: sIdx < p.registroDePrecinto.subDatas.length - 1 ? true : false }}
											>
												<View width={subW.n1} border={{ right: true }} justifyContent="center">
													<Text textAlign="center" fontSize="8px">{s.label}</Text>
												</View>
												<View width={subW.n2} border={{ right: true }} justifyContent="center">
													<Text textAlign="center" fontSize="8px">{formatDate(s.description4)}</Text>
												</View>
												<View width={subW.n3} border={{ right: true }} justifyContent="center">
													<Text textAlign="center" fontSize="8px">{s.description}</Text>
												</View>
												<View width={subW.n4} justifyContent="center" flexDirection="row">
													{getDocsArray(s.description2).map((url, i) => (
														<Link key={i} src={url} style={{ margin: "0 2px" }}>
															<Text color="#1d4ed8" fontSize="8px">Doc{i + 1}</Text>
														</Link>
													))}
												</View>
											</View>
										))}
									</View>
								</View>
							))}
						</View>
					</Page>
				</Document>
			</PDFViewer>
		</div>
	);
};

export default ReportPrecintosPDF;
